import { httpClient } from './httpClient';

interface TableRecords {
   chargers?: string | Array<string>;
   tenantId?: string;
   startDate?: any;
   endDate?: any;
   page: number;
   pageSize: number;
   setNewData?: any;
}

export const getRecords = (TableProps: TableRecords) => {
   const { chargers, page, pageSize } = TableProps;

   if (chargers) {
      return httpClient.get(
         `/v1/records?PageNumber=${page}&PageSize=${pageSize}&Keyword=${chargers}`
      );
   } else {
      return httpClient.get(`/v1/records?PageNumber=${page}&PageSize=${pageSize}`);
   }
};

export const filterRecords = (filterData: any) => {
   const {
      vendors,
      filterModel,
      filterOcpp,
      connectorNo,
      connectorType,
      qrCode,
      status,
      tenant,
      page,
      rowsPerPage,
      chargers,
   } = filterData;
   
   const updatedConnectorType =
      filterData?.connectorType !== ''
         ? filterData?.connectorType?.map((item: any) => {
              if (item === 'Type 1') {
                 return 'T1';
              }

              if (item === 'Type 2') {
                 return 'T2';
              }

              if (item === 'CCS Type 1') {
                 return 'T1CCS';
              }

              if (item === 'CCS Type 2') {
                 return 'T2CCS';
              }

              if (item === 'CHAdeMO') {
                 return 'C';
              }

              if (item === 'NACS') {
                 return 'NACS';
              }
              return null;
           })
         : '';

   return httpClient.get(
      `/v1/records?PageNumber=${page}&PageSize=${rowsPerPage}` +
         (chargers !== '' ? `&Keyword=${chargers}` : '') +
         (vendors !== undefined && vendors?.length > 0
            ? `&Filters.Vendors=${vendors ?? []}`
            : '') +
         (filterModel !== '' ? `&Filters.Model=${filterModel}` : '') +
         (filterOcpp !== '' ? `&Filters.OCPPVersion=${filterOcpp}` : '') +
         (connectorNo !== '' ? `&Filters.NoOfConnectors=${connectorNo}` : '') +
         (connectorType === undefined || connectorType?.length === 0
            ? ''
            : `&Filters.ConnectorType=${updatedConnectorType ?? []}`) +
         (status?.length === 0 ? '' : `&Filters.Status=${status ?? []}`) +
         (qrCode === '' ? '' : `&Filters.QRCode=${qrCode}`) +
         (tenant !== '' ? `&Filters.Tenant=${tenant}` : '')
   );
};
